import { Separator } from "@/components/ui/separator";

const SidebarSeparator = () => {
  return <Separator className="my-[12px] w-full h-[1px] bg-[#EDEDED] rounded" />;
};

export default SidebarSeparator;
